// src/hooks/jobOrders/useCreateJobOrder.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createJobOrder } from "../../api/apiJobOrders";
import toast from "react-hot-toast";

const useCreateJobOrder = () => {
    const queryClient = useQueryClient();

    const { mutate: createJobOrderMutate, isPending } = useMutation({
        mutationFn: ({ programId, data }) => createJobOrder(programId, data),
        onSuccess: (response, variables) => {
            toast.success("تم إنشاء أمر التشغيل والفاوتشر بنجاح");
            queryClient.invalidateQueries(["job-orders", variables.programId]);
        },
        onError: (error) => {
            const message = error.response?.data?.message || "حدث خطأ أثناء إنشاء أمر التشغيل";
            toast.error(message);
        }
    });

    return { createJobOrderMutate, isPending };
};

export default useCreateJobOrder;
